import CircleProgressBar from '@app/ProgressBar/CircleProgressBar'
import LinearProgressBar from '@app/ProgressBar/LinearProgressBar'

export default function install(Vue) {
  Vue.component('CircleProgressBar', CircleProgressBar)
  Vue.component('LinearProgressBar', LinearProgressBar)
}
